import { getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

export const generalApplicationCategory = data =>
  getInstance().get(`${API.GENERAL_APPLICATION_CATEGORY}${prop('id', data)}`, {
    params: dissoc('id', data),
  })

export const generalApplicationCategoryCreate = data => getInstance().post(API.GENERAL_APPLICATION_CATEGORY, data)

export const generalApplicationCategoryDelete = data =>
  getInstance().delete(`${API.GENERAL_APPLICATION_CATEGORY}${prop('id', data)}`)

export const generalApplicationCategoryList = data =>
  getInstance().get(API.GENERAL_APPLICATION_CATEGORY, {
    params: data,
  })

export const generalApplicationCategoryAll = data =>
  getInstance().get(API.GENERAL_APPLICATION_CATEGORY_ALL, {
    params: data,
  })
